import React, { Component } from 'react';
import StyledSelect from '../atoms/inputs/Select';

class LayerTypeCombo extends Component {
    render() {
        return (
            <StyledSelect {...this.props.input}>
                <option value='' className="choose">
                CHOOSE ONE...
                </option>
                <option value="2">
                    Parent (Layer 2)
                </option>
                <option value="3">
                    Child (Layer 3)
                </option>
            </StyledSelect>
        );
    }
}

export default LayerTypeCombo;



// WEBPACK FOOTER //
// ./src/components/molecules/LayerTypeCombo.js